module.exports = __webpack_public_path__ + "img/oil_paint_large_5.d5302b73.png";